import { z } from 'zod'

import { VatValidationStatus } from '@forto-dev/customer-master-data-models'

export const VatValidationDataSchema = z.object({
  status: z.nativeEnum(VatValidationStatus),
  countryCode: z
    .string()
    .nullish()
    .transform((data) => data ?? ''),
  companyName: z
    .string()
    .nullish()
    .transform((data) => data ?? ''),
})

export type VatValidationData = z.infer<typeof VatValidationDataSchema>
